import * as React from "react";
import {faRocket}                   from "@fortawesome/free-solid-svg-icons";
import {faCaretDown}                from "@fortawesome/free-solid-svg-icons";
import {faCaretUp}                  from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon}            from "@fortawesome/react-fontawesome";
import {xdQAattribute}              from "../../analytics-layout";
import {ADDRESS_LIST_MESSAGE}       from "../../analytics-address-list-modal/analytics-address-list-modal";

import "./analytics-actions.scss";

export const AnalyticsActions = ({
    acceptLeads,
    leadInteractionsSelected,
    createMailingList,
    setAddressListLeadsIncluded,
    addressListMessage, setAddressListMessage,
    addressListLeadsExcluded, setAddressListLeadsExcluded,
    leadsSelected, setLeadsSelected,
    showActions, setShowActions
}) => {
    
    const executeAcceptLeads = (leadInteractions) => {
        const idLeads = []
        leadInteractions.forEach(interaction => {
            if(!interaction.agentAccepted) {
                idLeads.push(interaction.idLead)
            }
        })
        acceptLeads(idLeads)
    }

    const executeCreateAddressList = (leadInteractions) => {
        setAddressListLeadsExcluded(null)
        const leadsValidAddress = []
        const leadsInvalidAddresses = []
        leadInteractions.forEach(interaction => {
            if(interaction.address && interaction.zip) {
                const {name = '', address = '', address2 = '', city = '', state = '', zip = ''} = interaction
                const firstname = name
                const street = address
                const entry = {firstname, street, address2, city, state, zip}
                leadsValidAddress.push(entry)
                return
            }
            leadsInvalidAddresses.push(interaction)
        })

        const validAddressesNonZero = leadsValidAddress.length > 0
        const inValidAddressesNonZero = leadsInvalidAddresses.length > 0

        switch(true) {
            case validAddressesNonZero && inValidAddressesNonZero:
                setAddressListLeadsExcluded(leadsInvalidAddresses)
                setAddressListLeadsIncluded(leadsValidAddress)
                setAddressListMessage(ADDRESS_LIST_MESSAGE.PENDING)
                break
            case validAddressesNonZero && !inValidAddressesNonZero:
                createMailingList(leadsValidAddress)
                break
            case !validAddressesNonZero && inValidAddressesNonZero:
                setAddressListLeadsExcluded(leadsInvalidAddresses)
                setAddressListMessage(ADDRESS_LIST_MESSAGE.INVALID)
                break
            case !validAddressesNonZero && !inValidAddressesNonZero:
            default:
                setAddressListMessage(ADDRESS_LIST_MESSAGE.NONE)
                break
        }
    }

    const actions = [
        {
            type: 'acceptLead',
            label: 'Mark as seen',
            execute: executeAcceptLeads
        },
        {
            type: 'createAddressList',
            label: 'Create Address List',
            execute: executeCreateAddressList
        },
    ]

    return (
        <div className="actions-4bh2o">
            <div className={`actions-overlay ${showActions ? 'expanded' : 'collapsed'}`}
                onClick={(e) => {
                    e.stopPropagation()
                    setShowActions(false)
                }}
            />
            <button 
                className={`show-actions${leadsSelected.length < 1 ? ' not-allowed disabled' : ''}`}
                onClick={(e) => {
                    e.stopPropagation()
                    if(leadsSelected.length < 1) {
                        return
                    }
                    const showingActions = showActions
                    setShowActions(!showingActions)
                }}
                {...xdQAattribute('button', `show actions${leadsSelected.length < 1 ? ' disabled' : ''}`)}
            >
                <FontAwesomeIcon
                    className='icon rocket'
                    icon={faRocket}
                />
                <p className="text-actions">Actions</p>
                <FontAwesomeIcon
                    className='icon caret'
                    icon={showActions ? faCaretUp : faCaretDown}
                />
            </button>
            <div className={`actions-menu ${showActions ? 'expanded' : 'collapsed'}`}>
                <Action 
                    action={actions[0]}
                    {...{
                        leadInteractionsSelected,
                        setShowActions,
                        leadsSelected, setLeadsSelected
                    }}
                />
                <div className="action-header">
                    <hr className="hr-leading" />
                    <p className="marketing">MARKETING</p>
                    <hr className="hr-trailing" />
                </div>
                <Action 
                    action={actions[1]}
                    {...{
                        leadInteractionsSelected,
                        setShowActions,
                        leadsSelected, setLeadsSelected
                    }}
                />
            </div>
        </div>
    )
}

const Action = ({
    action, 
    leadInteractionsSelected,
    setShowActions,
    leadsSelected, setLeadsSelected
}) => {
    return (
        <div 
            className="action"
            onClick={(e) => {
                e.stopPropagation()
                if(leadsSelected.length < 1) {
                    return
                } 
                const leadInteractions = leadInteractionsSelected()
                action.execute(leadInteractions)
                setLeadsSelected([])
                setShowActions(false)
            }}
            {...xdQAattribute('dropdown_item', action.type)}
        >
            {action.label}
        </div>
    )
}